<template>
  <div>
    <v-row v-for="(social, index) in formData.socialNetworks" :key="index">
      <v-col cols="12" md="5">
        <v-text-field v-model="social.url" label="URL" outlined dense />
      </v-col>
      <v-col cols="12" md="5">
        <v-select
          v-model="social.type"
          :items="socialTypes"
          label="Tipo"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="error" icon @click="removeSocialNetwork(index)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-btn color="primary" text @click="addSocialNetwork">
      Adicionar Rede Social
    </v-btn>

    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: "SocialNetworksStep",
  props: {
    value: {
      type: Object,
      required: true,
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    socialTypes: [
      { text: "Instagram", value: "ig" },
      { text: "Twitter", value: "tw" },
      { text: "TikTok", value: "tt" },
      { text: "Facebook", value: "fb" },
      { text: "YouTube", value: "yt" },
    ],
  }),
  computed: {
    hasChanges() {
      const oldSocial = JSON.stringify(this.oldValue.socialNetworks || {});
      const newSocial = JSON.stringify(this.value.socialNetworks || {});

      return oldSocial !== newSocial;
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getFormData() {
      if (!this.hasChanges) return false;
      return {
        socialNetworks: this.formData.socialNetworks,
      };
    },
    addSocialNetwork() {
      this.formData.socialNetworks.push({ url: "", type: "ig" });
    },

    removeSocialNetwork(index) {
      this.formData.socialNetworks.splice(index, 1);
    },
  },
};
</script>
